import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { GamificationService } from '../../shared/gamification.service';
import { LevelProgressService } from '../../shared/level-progress/level-progress.service';
import { OeAppPersonService } from '../../shared/oe-app-person.service';
import { OeAppService } from '../../shared/oe-app.service';
import { ProfileServiceConfigurationService } from '../../shared/profile-service-configuration.service';
import { BilingualFallbackType } from '../../shared/types/bilingual-fallback-type';
import { GamificationActivityType } from '../../shared/types/gamification-activity-type';
import { TeacherType } from '../../shared/types/teacher-type';
import { myCoachService } from '../my-coach-section/my-coach.service';

@Component({
  selector: 'lp2-study-bundle',
  templateUrl: './study-bundle.component.html',
  styleUrls: ['./study-bundle.component.scss'],
})
export class StudyBundleComponent implements OnInit {
  @ViewChild('mobileLockout')
  mobileLockoutContent: ElementRef;
  showOnboardingBanner: boolean;
  activityPoints$: Observable<Map<GamificationActivityType, number>>;
  hasCoachAccess$ = this.myCoachService.hasCoachAccess$();
  coachStudyPlan: string;
  preferredTeacherType: TeacherType;
  fallBackLiveClassTeacherType: BilingualFallbackType;
  lcOnboardingTaken: boolean;
  bilingualEnabled: boolean;
  isLiveClassOnboardingEnabled$ = this.profileServiceConfigurationService.isLiveClassOnboardingEnabled$();
  iscEnabled = this.oeAppPersonService.iscEnabled;
  liveClassEnabled: boolean;
  copilotEnabled = false;
  yearInReviewEnabled$ = this.profileServiceConfigurationService.yearInReviewEnabled$();
  lessonEnabled = this.oeAppPersonService.lessonEnabled;
  unitIndexEnabled = this.oeAppPersonService.unitIndexEnabled;

  constructor(
    private readonly levelProgressService: LevelProgressService,
    private readonly modalService: NgbModal,
    private readonly oeApp: OeAppService,
    private readonly oeAppPersonService: OeAppPersonService,
    private readonly gamificationService: GamificationService,
    private readonly profileServiceConfigurationService: ProfileServiceConfigurationService,
    private readonly myCoachService: myCoachService,
  ) {}

  async ngOnInit() {
    this.levelProgressService.updateLevelProgress();
    if (this.oeApp.isOpenEnglishDevice()) {
      this.modalService.open(this.mobileLockoutContent);
    }

    this.activityPoints$ = this.gamificationService.getActivityPointsMap();

    this.liveClassEnabled = this.oeAppPersonService.liveClassEnabled;

    this.coachStudyPlan = this.myCoachService.coachStudyPlan();

    this.lcOnboardingTaken = this.oeAppPersonService.isLcOnboardingTaken;

    this.bilingualEnabled = this.oeAppPersonService.isBilingualEnabled;

    this.preferredTeacherType = this.oeAppPersonService.preferedTeacherType;

    this.fallBackLiveClassTeacherType = this.oeAppPersonService.fallBackLiveClassTeacherType;

    this.copilotEnabled = this.oeAppPersonService.copilotEnabled;

    this.unitIndexEnabled = this.oeAppPersonService.unitIndexEnabled;
  }

  public onLcOnboardingFinished(preferredTeacherType: TeacherType): void {
    this.preferredTeacherType = preferredTeacherType;
    this.lcOnboardingTaken = true;
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/study-bundle/study-bundle.component.ts